import { useMemo } from 'react';
import { PlanStatuses } from '@common-fe/common-fe';

import { useGetOrganizationPlansQuery } from '@/modules/employee/Employee/queries/useGetOrganizationPlans.query';
import useGetEmployer from '@/modules/employer/hooks/useGetEmployer.query';

const TOOLTIP_TEXT = 'Lock/unlock is not available for terminated organization';

export const useIsLockUnlockAvailable = () => {
  const { formattedData: employerData } = useGetEmployer();
  
  const employerId = useMemo(() => employerData?.normalProperties?.organizationId, [employerData]);
  const { formattedData } = useGetOrganizationPlansQuery(employerId ? `${employerId}` : undefined);

  const isAllPlansTerminated = useMemo(() => {
    if (!formattedData || formattedData.length === 0) return false;
    return formattedData.every((plan) => plan.planStatus === PlanStatuses.TERMINATED);
  }, [formattedData]);

  return {
    isLockUnlockDisabled: employerData?.isTerminated || isAllPlansTerminated,
    tooltipText: TOOLTIP_TEXT,
  };
};
